module.exports = __webpack_public_path__ + "22cfd3f25882a8f725f344708b552d20.svg";